/* LuxuryGel theme JS: cart drawer, AJAX add to cart, quantity, gallery, sticky ATC, search, mobile nav, predictive search */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let out = format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec);
    return out.replace(/<[^>]+>/g, '');
  }
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2400);
  }

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');
  function openDrawer() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const c = $('.cart-drawer__close', drawer); c && c.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  window.theme.openCart = openDrawer;

  async function refreshDrawer(openAfter) {
    if (!drawer) return;
    try {
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer-content', { headers: { Accept: 'text/html' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawerContent') || doc.querySelector('#shopify-section-cart-drawer-content') || doc.body;
      const current = $('#CartDrawerContent');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const count = doc.querySelector('[data-cart-count]');
      if (count) $$('[data-cart-count]').forEach(el => { el.textContent = count.textContent; el.dataset.count = count.dataset.count; });
    } catch (e) { /* silent */ }
    if (openAfter) openDrawer();
  }
  window.theme.refreshCart = refreshDrawer;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshDrawer(true); }
    if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__overlay')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeSearch(); closeMobileNav(); } });

  /* ---------- Add to cart (any form[data-ajax-cart]) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    btn && btn.classList.add('loading');
    try {
      const fd = new FormData(form);
      const res = await fetch(window.theme.cartAddUrl + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!res.ok) { const err = await res.json().catch(() => ({})); toast(err.description || err.message || 'Could not add to cart'); return; }
      await refreshDrawer(true);
    } catch (err) { toast('Could not add to cart'); }
    finally { btn && btn.classList.remove('loading'); }
  });

  /* ---------- Quick add buttons (button[data-quick-add][data-variant-id]) ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('loading');
    try {
      const res = await fetch(window.theme.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.variantId), quantity: 1 }) });
      if (!res.ok) { toast('Could not add to cart'); return; }
      await refreshDrawer(true);
    } finally { b.classList.remove('loading'); }
  });

  /* ---------- Cart line changes (drawer + cart page) ---------- */
  async function changeLine(line, quantity) {
    const res = await fetch(window.theme.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }) });
    return res.json();
  }
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    const qb = e.target.closest('[data-qty-change]');
    if (rm) {
      e.preventDefault();
      await changeLine(rm.dataset.line, 0);
      if (rm.closest('.cart-drawer')) refreshDrawer(false); else window.location.reload();
    }
    if (qb) {
      e.preventDefault();
      const input = qb.parentElement.querySelector('input');
      let v = Number(input.value) + Number(qb.dataset.qtyChange);
      if (v < (input.min ? Number(input.min) : 0)) v = Number(input.min || 0);
      input.value = v;
      if (input.dataset.line) {
        await changeLine(input.dataset.line, v);
        if (input.closest('.cart-drawer')) refreshDrawer(false); else window.location.reload();
      }
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target;
    if (input.matches('input[data-line]')) {
      await changeLine(input.dataset.line, input.value);
      if (input.closest('.cart-drawer')) refreshDrawer(false); else window.location.reload();
    }
  });

  /* ---------- Mobile nav ---------- */
  const mobileNav = $('#MobileNav');
  function closeMobileNav() { if (mobileNav) { mobileNav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-nav-open]')) { mobileNav && mobileNav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-nav-close]')) closeMobileNav();
  });

  /* ---------- Search modal + predictive ---------- */
  const searchModal = $('#SearchModal');
  function closeSearch() { searchModal && searchModal.classList.remove('is-open'); }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); searchModal && searchModal.classList.add('is-open'); const i = $('input[type="search"]', searchModal); i && setTimeout(() => i.focus(), 50); }
    if (e.target.closest('[data-search-close]') || (searchModal && e.target === searchModal)) closeSearch();
  });
  let searchTimer;
  document.addEventListener('input', (e) => {
    const input = e.target;
    if (!input.matches('[data-predictive-input]')) return;
    const results = $('[data-predictive-results]');
    if (!results) return;
    clearTimeout(searchTimer);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const url = window.theme.predictiveSearchUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#PredictiveSearchResults');
        results.innerHTML = inner ? inner.innerHTML : '';
      } catch (err) { /* ignore */ }
    }, 250);
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const main = $('[data-main-image]');
    if (main) { main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || ''; }
    $$('[data-thumb]').forEach(x => x.removeAttribute('aria-current'));
    t.setAttribute('aria-current', 'true');
  });

  /* ---------- Variant selection (for multi-variant products) ---------- */
  $$('form[data-product-form]').forEach((form) => {
    const json = form.querySelector('[data-product-json]');
    if (!json) return;
    let product; try { product = JSON.parse(json.textContent); } catch (e) { return; }
    const selects = $$('[data-option-select]', form);
    if (!selects.length) return;
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = $('[data-product-price]');
    const compareEl = $('[data-product-compare]');
    const btn = form.querySelector('[type="submit"]');
    function update() {
      const chosen = selects.map(s => s.value);
      const v = product.variants.find(v => chosen.every((c, i) => v['option' + (i + 1)] === c));
      if (!v) { btn.disabled = true; btn.textContent = window.theme.strings.unavailable; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; }
      btn.disabled = !v.available;
      btn.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_image) { const main = $('[data-main-image]'); if (main) main.src = v.featured_image.src; }
    }
    selects.forEach(s => s.addEventListener('change', update));
  });


  /* ---------- Bundle & save selector (product page) ---------- */
  $$('[data-bundle-selector]').forEach((sel) => {
    const form = sel.closest('form');
    if (!form) return;
    const idInput = form.querySelector('input[name="id"]');
    const totals = $$('[data-bundle-total]');
    function apply(radio) {
      $$('[data-bundle-tier]', sel).forEach((tier) => {
        const active = tier.contains(radio);
        tier.classList.toggle('is-active', active);
        $$('[data-bundle-input]', tier).forEach((inp) => { inp.disabled = !active; });
      });
      if (idInput) idInput.value = radio.dataset.variantId;
      const price = Number(radio.dataset.price || 0);
      totals.forEach((t) => { t.textContent = formatMoney(price); });
    }
    sel.addEventListener('change', (e) => {
      if (e.target.matches('input[name="bundle_tier"]')) apply(e.target);
      if (e.target.matches('.bundle-slot__select')) e.target.classList.toggle('is-filled', !!e.target.value);
    });
    sel.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-bundle-switch]');
      if (!sw) return;
      e.preventDefault();
      const r = sel.querySelector('input[name="bundle_tier"][value="' + sw.dataset.bundleSwitch + '"]');
      if (r) { r.checked = true; apply(r); }
    });
    const checked = sel.querySelector('input[name="bundle_tier"]:checked') || sel.querySelector('input[name="bundle_tier"]');
    if (checked) { checked.checked = true; apply(checked); }
    form.addEventListener('submit', (e) => {
      const missing = $$('.bundle-slot__select:not(:disabled)', sel).find((s) => !s.value);
      if (missing) { e.preventDefault(); e.stopImmediatePropagation(); missing.focus(); toast(window.theme.strings && window.theme.strings.chooseScent || 'Pick a scent for every bottle first'); }
    }, true);
  });

  /* ---------- Sticky add to cart ---------- */
  const sticky = $('[data-sticky-atc]');
  const buyBox = $('[data-buy-box]');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      entries.forEach(en => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
    }, { threshold: 0 }).observe(buyBox);
    sticky.addEventListener('click', (e) => {
      if (e.target.closest('[data-sticky-submit]')) { const f = $('form[data-product-form]'); f && f.requestSubmit(); }
    });
  }

  /* ---------- Free shipping bar ---------- */
  function updateShippingBars(total) {
    $$('[data-shipping-bar]').forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || window.theme.shippingThreshold || 0);
      const fill = bar.querySelector('.shipping-bar__fill');
      const label = bar.querySelector('[data-shipping-label]');
      const pct = threshold ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
      if (fill) fill.style.width = pct + '%';
      if (label) label.textContent = total >= threshold ? bar.dataset.doneText : bar.dataset.remainingText.replace('[amount]', bar.dataset.mode === 'items' ? String(threshold - total) : formatMoney(threshold - total));
    });
  }
  window.theme.updateShippingBars = updateShippingBars;
  $$('[data-shipping-bar]').forEach(b => updateShippingBars(Number(b.dataset.total || 0)));


  /* ---------- Countdown ([days] placeholder) ---------- */
  function updateCountdowns() {
    $$('[data-countdown]').forEach((el) => {
      const target = new Date(el.dataset.countdown + 'T23:59:59');
      if (isNaN(target)) return;
      const days = Math.ceil((target - new Date()) / 86400000);
      const tpl = el.dataset.countdownText || el.textContent;
      if (days < 0) { el.hidden = true; return; }
      el.textContent = tpl.replace('[days]', String(days));
    });
  }
  updateCountdowns();
  document.addEventListener('shopify:section:load', updateCountdowns);

  /* ---------- Section rendering hook for theme editor ---------- */
  document.addEventListener('shopify:section:load', () => { $$('[data-shipping-bar]').forEach(b => updateShippingBars(Number(b.dataset.total || 0))); });
})();
